import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { validators } from '../../utils/helpers/validators'
import PhotoCircle from '../photos/PhotoCircle'
import { updateProfile } from '../../slices/profile'
import LabeledText from '../common/form-components/labeled-inputs/LabeledText'
import LabeledPassword from '../common/form-components/labeled-inputs/LabeledPassword'
import SaveButton from '../common/buttons/SaveButton'
import './profile-form.scss'

const ProfileForm = ({ toggle }) => {
  const dispatch = useDispatch()

  const { resp: profile } = useSelector((state) => state.profile)

  const [inputs, setInputs] = useState(profile)

  const updateProfileData = (body) => dispatch(updateProfile(body))

  const onChange = ({ target: { value, name } }) => {
    setInputs({ ...inputs, [name]: value })
  }

  const handleSubmit = async () => {
    const resp = await updateProfileData(inputs)
    if (resp) toggle()
  }

  const validateConfirmPassword = () =>
    validators.equals(inputs?.newPassword, inputs?.confirmPassword)

  const validateForm = () => {
    const isChangePassword = inputs?.password
    if (isChangePassword) {
      return (
        validators.hasValue(inputs?.name) &&
        validators.hasValue(inputs?.username) &&
        validators.emailFormat(inputs?.email) &&
        validators.passwordFormat(inputs?.password) &&
        validateConfirmPassword() &&
        validators.passwordFormat(inputs?.newPassword)
      )
    }

    return (
      validators.hasValue(inputs?.name) &&
      validators.hasValue(inputs?.username) &&
      validators.emailFormat(inputs?.email)
    )
  }

  return (
    <div className="profile-container">
      <div className="modal-content-wrapper">
        <div className="info-profile-modal">
          <div className="imgProfile">
            <PhotoCircle image={profile?.image} />
          </div>
          <div className="info-user-profile">
            <LabeledText
              idLabel="name"
              required
              name="name"
              value={inputs?.name}
              onChange={onChange}
            />

            <LabeledText
              idLabel="username"
              required
              name="username"
              value={inputs?.username}
              onChange={onChange}
            />

            <LabeledText
              idLabel="email"
              required
              name="email"
              value={inputs?.email}
              onChange={onChange}
            />
          </div>
        </div>

        <div className="password">
          <LabeledPassword
            idLabel="password.current"
            required
            name="password"
            value={inputs?.password}
            placeholder
            onChange={(e) => onChange(e)}
          />

          <LabeledPassword
            idLabel="password.new"
            required
            name="newPassword"
            value={inputs?.newPassword}
            onChange={(e) => onChange(e)}
            feedback
            placeholder
          />

          <LabeledPassword
            idLabel="password.confirm"
            required
            name="confirmPassword"
            value={inputs?.confirmPassword}
            placeholder
            onChange={(e) => onChange(e)}
          />
        </div>
      </div>
      <div className="modal-btn-container">
        <SaveButton
          onClick={() => handleSubmit()}
          isDisabled={!validateForm()}
          btnClass="btn-save-modal"
        />
      </div>
    </div>
  )
}

export default ProfileForm
